
import { Button, Menu, MenuHandler, MenuItem, MenuList, Spinner, Typography } from '@material-tailwind/react'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import BalanceBadges from '../../components/BalanceBadges'
import MoreDotsIcon from '../../images/icons/MoreDotsIcon'
import { useIndexContractsQuery } from '../../store/auth/authService'
import { setContractId, setServiceId } from '../../store/service/contractSlice'
import { AppDispatch, RootState } from '../../store/store'
import { isIterableArray, numWord, replacedString } from '../../utils/utils'
import CompaniesSkeleton from './CompaniesSkeleton'
import CompanyTable from './CompanyTable'
import Filters from './Filters'
import TableToolbar from '../tableHelpers/TableToolbar'
import { setCrumbsContract } from '../../store/service/headerSlice'
import { Helmet } from 'react-helmet'
import PageLayout from '../../layouts/pagesLayouts/PageLayout'
import TableLayout from '../../layouts/pagesLayouts/TableLayout'
import { ROWS_PER_PAGE } from '../tableHelpers/tableConfig'
import PaginationEl from '../tableHelpers/PaginationEl'
import ArrowAccordionIcon from '../../images/icons/ArrowAccordionIcon'
import DrawerViewBalances from './viewBalances/DrawerViewBalances'
import ModalNewConnnection from '../../components/newConnection/ModalNewConnnection'
import { hasRoleAccess } from '../../utils/roles'
import useRolePage from '../../utils/useRolePage'

const CompaniesPage = () => {

    const { data: roles } = useRolePage();

    const { t } = useTranslation()

    const dispatch = useDispatch<AppDispatch>()
    const { service_id } = useSelector((state: RootState) => state.contract)

    const [filterStatus, setFilterStatus] = useState<number[]>([]);
    const [filterContract, setFilterContract] = useState<number[]>([]);

    const { data, error, isLoading, isFetching, refetch } = useIndexContractsQuery<any>({
        service_id: service_id || 1
    })

    const [isOpenFilters, setIsOpenFilters] = useState<boolean>(false); // drawer 

    const [selectedContracts, setSelectedContracts] = useState<{ [key: string]: number[] }>({}); // объект выбранных контрактов 
    const [formattedSelected, setFormattedSelected] = useState<number[]>([]); // массив выбранных id всех контрактов

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE[0]);


    const [tableRows, setTableRows] = useState<any[]>([]);
    const [search, setSearch] = useState<string>('');

    const isShow = (contract: any, filterContractProp: number[]) => isIterableArray(filterContractProp) ? filterContractProp.find(item => item === contract.id) : true
    // кол-во страниц в пагинации
    const paginationCount = Math.ceil(tableRows?.filter((i: any) => !!isShow(i, filterContract))?.length / rowsPerPage)





    useEffect(() => {
        if (isIterableArray(data?.contracts)) {
            setTableRows(data.contracts)
        }
        else setTableRows([])
    }, [data]);

    useEffect(() => {
        dispatch(setContractId(0))
        dispatch(setCrumbsContract([]))
    }, []);

    useEffect(() => {
        // при изменении сервиса - чистим фильтры
        setFilterContract([])
        setFilterStatus([])
        if (!service_id) dispatch(setServiceId(1))
    }, [service_id]);

    useEffect(() => {
        const formatterIds = () => {
            let res: number[] = []
            Object.keys(selectedContracts).map(key => {
                if (selectedContracts[key]) res = [...res, ...selectedContracts[key]]
            })

            setFormattedSelected(res)
        }
        if (isIterableArray(Object.keys(selectedContracts))) formatterIds()
        else setFormattedSelected([])
    }, [selectedContracts]);

    useEffect(() => {
        setPage(1)
    }, [data?.contracts])


    const handleSetSelected = (contractSel: { [key: string]: number[] }) => {
        setPage(1)
        setSelectedContracts(prev => ({
            ...prev,
            ...contractSel
        }))
    }
    const handleResetSelected = (contractSel?: { [key: string]: number[] }) => {
        setPage(1)
        setSelectedContracts({})
    }

    const handleUpdatePage = (data: any) => {
        setPage(1)
        setSelectedContracts({})
        setFilterContract(isIterableArray(data.contract_id) ? data.contract_id : [])
        setFilterStatus(isIterableArray(data.status) ? data.status : [])
    }



    // .filter((i: any) => !!isShow(i))?
    const visibleContracts = React.useMemo(() => tableRows?.filter((i: any) => !!isShow(i, filterContract))?.slice(
        ((page - 1) * rowsPerPage) || 0,
        (page - 1) * rowsPerPage + rowsPerPage,
    ),
        [page, rowsPerPage, tableRows, filterContract]
    );

    const handleChangeRowsPerPage = (value: any) => {
        setRowsPerPage(parseInt(value, 10));
        setPage(1);
    };

    const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const onSearch = (searchValue: string) => {
        setSearch(searchValue);
        const reg = new RegExp(replacedString(searchValue), "gi");
        if (searchValue === "") {
            setTableRows(data?.contracts)
            return
        }
        if (isIterableArray(data?.contracts)) {
            const filteredData: any[] = data?.contracts.filter((item: any) => {
                const keys = Object.keys(item);
                let matches = 0;
                keys.forEach((key) => {
                    const val = replacedString(String(item[key]))
                    if (reg.test(val)) matches++;
                });
                return matches > 0;
            });
            const filteredWithItemsData: any[] = filteredData.map((item: any) => {

                const newItems = item.items.filter((i_item: any) => {
                    const k_keys = Object.keys(i_item);
                    let m_matches = 0;

                    k_keys.forEach((k_key) => {
                        const val = String(i_item[k_key]).replaceAll(' ', '')
                        if (reg.test(val)) m_matches++;
                    });
                    return m_matches > 0;
                });

                return { ...item, items: newItems };
            });
            if (searchValue !== "" && filteredWithItemsData.length > 0) {
                setTableRows(filteredWithItemsData);
            }
            if (searchValue !== "" && filteredWithItemsData.length === 0) {
                setTableRows([]);
            }
        }
    };

    const [isOpenBalancesDrawer, setIsOpenBalancesDrawer] = useState<boolean>(false);

    const [balancesSelectData, setBalancesSelectData] = useState(null);


    const handleOpenBalancesDrawer = (val: any = null) => {
        setIsOpenBalancesDrawer(true)

        if (val) setBalancesSelectData(val)
    }
    const handleCloseBalancesDrawer = () => {
        setIsOpenBalancesDrawer(false)
        setBalancesSelectData(null)
    }

    const [isOpenModalConnection, setIsOpenModalConnection] = useState<boolean>(false)

    const handleCloseModal = () => {
        setIsOpenModalConnection(false)
    }
    const handleOpenModal = () => {
        setIsOpenModalConnection(true)
    }

    const isDisabledBalances = useCallback(
        () => {
            if (roles && hasRoleAccess('payments.view', roles)) return false
            return true
        },
        [roles],
    )

    return (
        // px-[48px]
        <>
            <ModalNewConnnection
                open={isOpenModalConnection}
                handleClose={handleCloseModal}
                currentServiceId={service_id === 1 ? 1 : 2}
            />
            <PageLayout>
                <DrawerViewBalances
                    open={isOpenBalancesDrawer}
                    handleClose={handleCloseBalancesDrawer}
                    legalItems={data?.legalFilters}
                    contracts={data?.contracts}
                    contractItems={balancesSelectData}
                />
                <div className='pb-[128px]'>
                    <Helmet>
                        <title>
                            {t('companies.title_page')}
                        </title>
                    </Helmet>
                    <TableToolbar isOpen={formattedSelected?.length > 0} >
                        {/* <Button color='white' className='w-[50px] h-[50px] px-0 border-0' onClick={() => handleResetSelected()}>X</Button> */}
                        <Typography
                            color="inherit"
                        // component="div" 
                        >
                            {t('selected')}
                            <span className='font-bold'> {formattedSelected.length}  {t(`mainpage.active_count_${numWord(formattedSelected.length)}`)}</span>
                        </Typography>
                        <Menu placement="top" >
                            <MenuHandler>
                                <Button color='light-blue' className='w-60 flex items-center justify-between'>
                                    {t('action')}
                                    <MoreDotsIcon />
                                </Button>
                            </MenuHandler>
                            <MenuList className='w-60'>
                                <MenuItem>Menu Item 1</MenuItem>
                                <MenuItem>Menu Item 2</MenuItem>
                                <MenuItem>Menu Item 3</MenuItem>
                            </MenuList>
                        </Menu>
                    </TableToolbar>

                    <div className='w-full flex flex-col  tab:flex-row items-center justify-between '>
                        <Typography variant='h3' className='text-center tab:text-left  mb-[24px] tab:mb-0 grow'>
                            {t('companies.title_page')}
                        </Typography>
                        <BalanceBadges
                            service_id={service_id}
                            isFetching={isFetching}
                            className='flex-col w-full tab:!w-[auto]'
                            contClassName={'!grid grid-cols-2 tab:!flex w-full tab:!w-[auto]'}
                            items={data?.total}
                            // handleOpenBalancesDrawer={() => handleOpenBalancesDrawer()}
                            handleOpenBalancesDrawer={isDisabledBalances() ? null : () => handleOpenBalancesDrawer()}
                        />
                    </div>

                    {
                        (isIterableArray(visibleContracts) || search) ?
                            <Filters
                                isFetching={isFetching}
                                isOpenFilters={isOpenFilters}
                                setIsOpenFilters={setIsOpenFilters}

                                defaultValue={{
                                    status: filterStatus,
                                    contracts: filterContract
                                }}
                                legalFilters={data?.legalFilters}
                                handleUpdatePage={handleUpdatePage}
                                onSearch={onSearch}
                            />
                            :
                            <div className='h-[150px]' />
                    }


                    {
                        isFetching ?
                            <div>
                                <div className='hidden tab:block'>
                                    <CompaniesSkeleton service_id={service_id} />
                                </div>
                                <Spinner className='tab:hidden mx-auto my-[30px]' />
                            </div>
                            :
                            data ?
                                isIterableArray(visibleContracts) ?
                                    visibleContracts.map((contract: any, key: number) => {
                                        const isShow = isIterableArray(filterContract) ? filterContract.find(item => item === contract.id) : true
                                        return isShow ? (
                                            <CompanyTable
                                                key={key}
                                                roles={roles}
                                                filterStatus={filterStatus}
                                                contract={contract}
                                                service_id={service_id}
                                                handleSetSelected={handleSetSelected}
                                                handleResetSelected={handleResetSelected}

                                                handleOpenBalancesDrawer={isDisabledBalances() ? null : (k: any) => handleOpenBalancesDrawer(k)}
                                            // handleOpenBalancesDrawer={handleOpenBalancesDrawer}
                                            />
                                        )
                                            :
                                            ''
                                    })
                                    :
                                    search ?
                                        <TableLayout>
                                            <div className="flex flex-col items-center gap-[24px] my-[40px]">
                                                <Typography variant='lead' className='des:text-[20px] font-medium text-center '>
                                                    {t('no_companies_by_search')} "{search}"
                                                </Typography>
                                            </div>
                                        </TableLayout>
                                        :
                                        <TableLayout>
                                            <div className="flex flex-col items-center gap-[24px] my-[40px]">
                                                <Typography variant='lead' className='des:text-[20px] font-medium text-center '>
                                                    {t('no_companies_by_service')}
                                                </Typography>
                                                {
                                                    hasRoleAccess('profile.request', roles) &&
                                                    <Button onClick={handleOpenModal} color='black'>
                                                        {t('profile_menu.new_connection')}
                                                    </Button>
                                                }
                                            </div>
                                        </TableLayout>
                                :
                                error ?
                                    <TableLayout>
                                        <div className="flex flex-col items-center gap-[40px] my-[40px]">
                                            <Typography variant='lead' className='des:text-[20px] font-medium text-center '>
                                                {t('tables.error_on_loading')}
                                            </Typography>
                                            <Button onClick={refetch} color='black'>
                                                {t('reload')}
                                            </Button>
                                        </div>
                                    </TableLayout>
                                    :
                                    ''
                    }

                    {
                        isIterableArray(visibleContracts) &&
                        <div className='flex justify-center lap:grid lap:grid-cols-[1fr_4fr_1fr] mt-[64px]'>
                            <div className='hidden lap:flex items-center gap-[8px]'>
                                <Typography className='whitespace-nowrap text-[16px] text-gray-700'>
                                    {t('pagination.contractsPerPage')}
                                </Typography>

                                <Menu placement="top" >
                                    <MenuHandler>
                                        <Button color='white' className='w-[64px] h-[40px] rounded px-[16px] flex items-center justify-between gap-[6px]'>
                                            <span className='text-gray-700 text-[14px] font-normal'>{rowsPerPage}</span>
                                            <span className='rotate-180'><ArrowAccordionIcon /></span>
                                        </Button>
                                    </MenuHandler>
                                    <MenuList className='!min-w-[64px]'>
                                        {ROWS_PER_PAGE.map((i, key) =>
                                            <MenuItem key={key} className='text-center' onClick={() => handleChangeRowsPerPage(i)}>
                                                <span className='text-gray-700 text-[14px] font-normal'>
                                                    {i}
                                                </span>
                                            </MenuItem>
                                        )}
                                    </MenuList>
                                </Menu>
                            </div>
                            {
                                paginationCount > 1 &&
                                <div className='flex  justify-center items-center'>
                                    <PaginationEl
                                        count={paginationCount}
                                        page={page}
                                        onChange={handleChangePage}
                                    />
                                </div>
                            }
                        </div>
                    }
                </div>
            </PageLayout>
        </>
    )
}

export default CompaniesPage
